"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBenchmarkObservable = void 0;
const immer_1 = require("immer");
const rxjs_1 = require("rxjs");
const localStorage_1 = require("../util/localStorage");
const observable_1 = require("../util/observable");
const R = __importStar(require("ramda"));
const JetStream1 = __importStar(require("./Benchmarks/JetStream1"));
const JetStream2 = __importStar(require("./Benchmarks/JetStream2"));
const utils_1 = require("../util/utils");
const NQValue_1 = require("../NQValue");
const NQError_1 = require("../NQError");
function pastBenchmarkResult(logger) {
    const data = (0, localStorage_1.getBenchmarkResult)(logger);
    if (data === null) {
        return null;
    }
    if (Date.now() - data.timestamp < 30 * 24 * 3600 * 1e3) {
        return [
            {
                kind: NQValue_1.NQValueKind.BenchmarkIntermediate,
                result1: data.result1,
            },
            {
                kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable,
                result1: data.result1,
                result2: data.result2,
            }
        ];
    }
    else {
        return null;
    }
}
function saveResult(results) {
    const [r1, r2] = results;
    if (r1 === undefined ||
        r2 === undefined ||
        r1.kind !== NQValue_1.NQValueKind.BenchmarkIntermediate ||
        r2.kind !== NQValue_1.NQValueKind.BenchmarkFinalAvailable) {
        return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Bm-1-133", `got: ${(0, utils_1.safeStringify)(results)}`));
    }
    const data = {
        timestamp: Date.now(),
        result1: r1.result1,
        result2: r2.result2,
    };
    (0, localStorage_1.setBenchmarkResult)(data);
    return rxjs_1.EMPTY;
}
const computeGeomeans = (measurements) => {
    const sum = R.sum(measurements.map(Math.log));
    return Math.exp(sum * (1 / measurements.length));
};
const runBenchmarks = (benchmarks, logger) => __awaiter(void 0, void 0, void 0, function* () {
    const measurements = [];
    for (let b of benchmarks) {
        const m = yield b.measure();
        measurements.push(m);
    }
    logger.debug(`BENCHMARKS runBenchmarks, measurements = ${(0, utils_1.safeStringify)(measurements)}`);
    return computeGeomeans(measurements);
});
const runBenchmarkObservable = (logger) => new rxjs_1.Observable(subscriber => {
    (function asyncExecutionContext() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof document !== "object" || typeof window !== "object") {
                    subscriber.complete();
                    return;
                }
                const pastResult = pastBenchmarkResult(logger);
                if (pastResult != null) {
                    pastResult.forEach(r => subscriber.next(r));
                    subscriber.complete();
                    return;
                }
                const result1 = Math.round(yield runBenchmarks([new JetStream1.NBodyBenchmark(logger), new JetStream1.HashMapBenchmark(logger)], logger));
                logger.info(`messageEventHandler got result1: ${result1}`);
                subscriber.next((0, immer_1.freeze)({
                    kind: NQValue_1.NQValueKind.BenchmarkIntermediate,
                    result1: result1,
                }));
                if (result1 > 40) {
                    const result2 = Math.round(yield runBenchmarks([
                        new JetStream2.Cube3DBenchmark(logger),
                        new JetStream2.Box2DBenchmark(logger),
                        new JetStream2.NBodyCBenchmark(logger),
                        new JetStream2.DryCBenchmark(logger),
                        new JetStream2.QuicksortCBenchmark(logger),
                        new JetStream2.RegexDnaBenchmark(logger),
                        new JetStream2.TowersCBenchmark(logger)
                    ], logger));
                    logger.info(`messageEventHandler got result2: ${result2}`);
                    subscriber.next((0, immer_1.freeze)({
                        kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable,
                        result1: result1,
                        result2: result2,
                    }));
                    subscriber.complete();
                }
                else {
                    subscriber.next((0, immer_1.freeze)({
                        kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable,
                        result1: result1,
                        result2: null,
                    }));
                    subscriber.complete();
                }
            }
            catch (err) {
                subscriber.error(err);
            }
        });
    })();
    function dispose() {
    }
    ;
    return dispose;
});
const getBenchmarkObservable = (logger) => runBenchmarkObservable(logger).pipe((0, observable_1.summarizeThrough)(saveResult), (0, rxjs_1.timeout)(90000), (0, rxjs_1.timeInterval)());
exports.getBenchmarkObservable = getBenchmarkObservable;
//# sourceMappingURL=BenchmarkController.js.map